<app-navbar></app-navbar>
<div class="page-holder align-items-center bg-gray-100">
  <div class="container">
    <div class="row align-items-center">
      <div class="col-lg-4"></div>
      <div class="col-lg-4">
        <div class="text-center text-primary" style="margin:20px;">
          <img class="img-fluid" width="40%" src="assets/images/logo_suriname.png" alt="logo" />
<!--          <p class="mb-4 mt-4 text-muted">{{ 'LOGIN.LOGIN_MESSAGE' | translate }}</p>-->
        </div>
        <div class="card text-center">
          <div class="card-header px-lg-5">
            <div class="card-heading text-center">{{ 'LOGIN.TITLE' | translate }}</div>
          </div>
          <div class="card-body p-lg-4" style="margin-top: 20px; margin-bottom: 20px;">
            <form [formGroup]="loginForm">
              <mat-form-field appearance="outline" class="w-100 mb-3 form-field-width">
                <mat-label>{{ 'LOGIN.EMAIL_LABEL' | translate }}</mat-label>
                <input matInput formControlName="user" type="email" placeholder="{{ 'LOGIN.EMAIL_PLACEHOLDER' | translate }}" />
                @if (loginForm.get('user')?.hasError('email')) {
                  <mat-error>{{ 'LOGIN.EMAIL_INVALID_ERROR' | translate }}</mat-error>
                }
                @if (loginForm.get('user')?.hasError('required')) {
                  <mat-error>{{'COMMON.FIELD_REQUIRED' | translate}}</mat-error>
                }                
              </mat-form-field>

              <mat-form-field appearance="outline" class="w-100 mb-3 form-field-width">
                <mat-label>{{ 'LOGIN.PASSWORD_LABEL' | translate }}</mat-label>
                <input matInput formControlName="password" [type]="mostrarPassword ? 'text' : 'password'" required>
                @if (!mostrarPassword) {
                  <mat-icon matSuffix (click)="mostrarPassword = !mostrarPassword"> visibility_off </mat-icon>
                }
                @if (mostrarPassword) {
                  <mat-icon matSuffix (click)="mostrarPassword = !mostrarPassword"> visibility </mat-icon>
                }
                @if (loginForm.get('password')?.invalid) {
                  <mat-error>{{'COMMON.FIELD_REQUIRED' | translate}}</mat-error>
                }
              </mat-form-field>
              <div class="d-flex align-items-center mb-3" style="justify-content: end;">              
                <mat-label class="text-primary small" style="text-decoration: underline; cursor: pointer;" (click)="onAction()">{{ 'LOGIN.FORGOT_PASSWORD' | translate }}</mat-label>
              </div>
              <div class="d-flex align-items-center mb-3" style="justify-content: end;">              
                <mat-label class="small">{{ 'LOGIN.NOT_ACCOUNT' | translate }} <a (click)="actionRegister()" class="text-primary" style="text-decoration: underline; cursor: pointer;">{{ 'LOGIN.REGISTER' | translate }}</a></mat-label>
              </div>
              
              <button class="form-field-width" mat-flat-button color="primary" type="submit" (click)="login()"
                [disabled]="!loginForm.valid">
                {{ 'LOGIN.SUBMIT_BUTTON' | translate }}
              </button>
            </form>
          </div>
          <div class="card-footer px-lg-5">

          </div>
        </div>
      </div>
      <div class="col-lg-4"></div>
    </div>
  </div>
</div>

<app-footer></app-footer>